import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/course-codes',
        component: () => import('@/pages/course-codes/CourseCodesIndex.vue'),
        props: true,
        children: [
            {
                name: 'course-codes',
                path: '',
                component: () => import('@/components/course-codes/CourseCodesView.vue'),
                meta: {
                    title: 'Course Codes',
                    // opt into full-width via meta.dataTablePage
                    dataTablePage: true,
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view any course code'),
                },
                props: true,
            },
        ],
    },
    {
        path: '/course-codes/:courseCodeId',
        name: 'course-code-view',
        component: () => import('@/pages/course-codes/CourseCodeView.vue'),
        props: true,
        meta: {
            // opt into full-width via meta.dataTablePage
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a course code'),
        },
    },
];
